export type PersistentVoiceCallSource = {
  orgThreadId: string;
  organizationId: string;
  orgSlug: string;
  routeRef: string;
  title: string;
};

export type PersistentVoiceCall = PersistentVoiceCallSource & {
  sessionId: string;
};

export function beginPersistentVoiceCall(
  current: PersistentVoiceCall | null,
  source: PersistentVoiceCallSource,
  sessionId: string
): {
  call: PersistentVoiceCall;
  outcome: 'started' | 'already-active' | 'different-thread-active';
} {
  if (current) {
    return {
      call: current,
      outcome:
        current.orgThreadId === source.orgThreadId
          ? 'already-active'
          : 'different-thread-active',
    };
  }
  return { call: { ...source, sessionId }, outcome: 'started' };
}

export function shouldEndPersistentVoiceCallForPath(
  pathname: string,
  orgSlug: string
): boolean {
  const segments =
    pathname.split(/[?#]/, 1)[0]?.split('/').filter(Boolean) ?? [];
  const routeOrgSlug = segments[0];
  if (routeOrgSlug === 'shared' && segments.length === 1) return false;
  return (
    routeOrgSlug !== encodeURIComponent(orgSlug) && routeOrgSlug !== 'settings'
  );
}
